'use es6';

import PropTypes from 'prop-types';
import Big from 'UIComponents/elements/Big';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
function UnassignedQueueCount(props) {
  const {
    langQueueStatus: {
      queue,
      count
    }
  } = props;
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    marginBlockEnd: "200",
    children: /*#__PURE__*/_jsx(Big, {
      "data-test-id": "queue-status-big",
      weight: count > 0 ? 'bold' : 'regular',
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "queue-status-language-summary",
        message: "app.card.queue.status.summary",
        options: {
          count,
          language: queue
        }
      })
    })
  });
}
UnassignedQueueCount.propTypes = {
  langQueueStatus: PropTypes.shape({
    queue: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired
  })
};
export default UnassignedQueueCount;